module.exports = __webpack_public_path__ + "img/chengge.02d13b42.png";